import { render, staticRenderFns } from "./xskSkuJ.vue?vue&type=template&id=66d6851c&scoped=true"
import script from "./xskSkuJ.vue?vue&type=script&lang=js"
export * from "./xskSkuJ.vue?vue&type=script&lang=js"
import style0 from "./xskSkuJ.vue?vue&type=style&index=0&id=66d6851c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d6851c",
  null
  
)

export default component.exports